import React from 'react'
import { Route, Routes } from 'react-router-dom'
import PrivateRoute7  from '../../app/routes/PrivateRoute7'

import EditCatalogPhases from './EditCatalogPhases'
import ListCatalogPhases from './ListCatalogPhases'
import NewCatalogPhases from './NewCatalogPhases'

const AdminCatalogPhasesRoutes = () => {
  return (
    <Routes>
        <Route path="/" element={<PrivateRoute7><ListCatalogPhases /></PrivateRoute7>} />
        <Route path="edit-phase" element={<PrivateRoute7><EditCatalogPhases /></PrivateRoute7>} />
        <Route path="new-phase" element={<PrivateRoute7><NewCatalogPhases /></PrivateRoute7>} />
    </Routes>
  )
}

export default AdminCatalogPhasesRoutes